var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcEdit3 = function SvgIcEdit3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.32 14.48H.68c-.376 0-.68.286-.68.64v.72c0 .088.077.16.17.16h16.66c.094 0 .17-.072.17-.16v-.72c0-.354-.304-.64-.68-.64M3.096 12.8a.913.913 0 0 0 .128-.01l3.574-.59a.213.213 0 0 0 .112-.056l9.008-8.478a.19.19 0 0 0 0-.282L12.387.058A.217.217 0 0 0 12.236 0c-.058 0-.11.02-.151.058L3.077 8.536a.2.2 0 0 0-.06.106l-.626 3.364a.633.633 0 0 0 .021.321.665.665 0 0 0 .178.275c.14.128.317.198.506.198"
  })));
};
export default SvgIcEdit3;